import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  SeriesListingParams,
  TProductCard,
  TSeriesListing,
  TSeriesListingItemData,
  TSeriesListingProps,
} from '../types/seriesListing.types';

export class SeriesListingModel {
  private readonly data?: TSeriesListing;
  private readonly itemData?: TSeriesListingItemData;
  private readonly params?: SeriesListingParams;
  private readonly rendering?: ComponentRendering;
  private readonly isComponentUnreleased: boolean;

  constructor(props: TSeriesListingProps) {
    this.data = props?.fields?.apiData;
    this.itemData = props?.fields?.itemData;
    this.params = props?.params;
    this.rendering = props?.rendering;
    this.isComponentUnreleased = props?.fields?.isComponentUnreleased || false;
  }

  get thumbnailEE(): string {
    return this.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get items(): TProductCard[] {
    return this.data?.items || [];
  }

  get total(): number | undefined {
    return this.data?.total;
  }

  get baseUrl(): string {
    return this.itemData?.contextItemUrl || '';
  }

  get bodyTextVisibility(): 'show' | 'hide' {
    return this.params?.bodyTextVisibility ?? 'hide';
  }

  get isUnreleased(): boolean {
    return !!this.isComponentUnreleased;
  }
}
